export default __webpack_public_path__ + "static/media/christian.36a49d2f.jpg";